import varAxios from "../../../Comman/axios";

import { GetRolePermissionList,RegisterHeartRunnerUserUrl,getOrganizationSubAdminUrl,GetRegionListUrl,getHeartRunnerOrg, getCountryUrl} from "../../../Comman/apiEndPoints"

export const INSERT_HEARTRUNNER_DETAILS_REQUEST = "(insert) INSERT HEARTRUNNER REQUEST";
export const INSERT_HEARTRUNNER_DETAILS_SUCCESS = "(insert) INSERT HEARTRUNNER SUCCESS";
export const INSERT_HEARTRUNNER_DETAILS_ERROR = "(insert) INSERT HEARTRUNNER ERROR";

export const FETCH_HEARTRUNNER_ORG_REQUEST = "(registration) FETCH HEARTRUNNER ORG REQUEST";
export const FETCH_HEARTRUNNER_ORG_SUCCESS = "(registration) FETCH HEARTRUNNER ORG SUCCESS";
export const FETCH_HEARTRUNNER_ORG_ERROR = "(registration) FETCH HEARTRUNNER ORG ERROR";

export const FETCH_COUNTRY_LIST_DATA = "FETCH_COUNTRY_LIST_DATA";
export const FETCH_REGION_LIST_DATA = "FETCH_REGION_LIST_DATA";
export const FETCH_PERMISSIONS_LIST_DATA = "FETCH_PERMISSIONS_LIST_DATA";

export function insertHeartRunner(organizationDetails, dispatch) {
    // //debugger;    
    return (dispatch) => {
        
        dispatch(insertHeartRunnerDetailRequest(true));

        return varAxios.post(RegisterHeartRunnerUserUrl,organizationDetails,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
                .then((response) => {
                    
                    dispatch(
                        insertHeartRunnerDetailSuccess(false,
                         response.data.Message,
                         response.data.statusCode
                         
                         )
                    );
                })
                .catch((error) => {
                    
                     dispatch(
                        insertHeartRunnerDetailSuccess(false,
                         error.response.data.Message,
                         error.response.data.statusCode
                         
                         )
                    );
            })
    }
}


export function insertHeartRunnerDetailRequest(isLoading) {
    return {
        type: INSERT_HEARTRUNNER_DETAILS_REQUEST,
        isLoading
    }
}

export function insertHeartRunnerDetailSuccess(isLoading, errorMessage,statusCode) {
    return {
        type: INSERT_HEARTRUNNER_DETAILS_SUCCESS,
        isLoading,
        errorMessage,
        statusCode
    }
}

export function fetchHeartRunnerOrg(dispatch) {
    return (dispatch) => {
        dispatch(fetchHeartRunnerOrgRequest(true));
        return varAxios.get(getHeartRunnerOrg, 
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    fetchHeartRunnerOrgSuccess(
                        response.data,
                        false,
                    ));
            })
            .catch((error) => {
                dispatch(
                    fetchHeartRunnerOrgSuccess(
                        error.response.data,
                        false,
                    ));
                
            })
    }
}

export function fetchHeartRunnerOrgRequest(data,isLoading) {
    return {
        type: FETCH_HEARTRUNNER_ORG_REQUEST,
        data,
        isLoading
    }
}

export function fetchHeartRunnerOrgSuccess(heartRunnerOrgInfo,isLoading) {
    
    return {
        type: FETCH_HEARTRUNNER_ORG_SUCCESS,
        heartRunnerOrgInfo,
        isLoading
    }
}

export function getCountryListFunc() {
    return(dispatch) => {
        
       return varAxios.get(getCountryUrl)
       .then(response => {
           if(response.data.statusCode == 200){
            dispatch(
                fetchCountryListData(response.data.countryList)
                );
           }
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchCountryListData(list) {
    return {
        type: FETCH_COUNTRY_LIST_DATA,
        list
    }
}
export function getRegionListFunc() {
    let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
        
           if(response.data.statusCode == 200){
           
            dispatch(
                fetchRegionListData(response.data.regionList)
                );
           }
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchRegionListData(list) {
    return {
        type: FETCH_REGION_LIST_DATA,
        list
    }
}
export function getPermissionsListFunc() {
    return(dispatch) => {
        
       return varAxios.get(GetRolePermissionList)
       .then(response => {
        
           if(response.data.statusCode == 200){
           
            dispatch(
                fetchPermissionsListData(response.data.permissionList)
                );
           }
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchPermissionsListData(list) {
    return {
        type: FETCH_PERMISSIONS_LIST_DATA,
        list
    }
}